/**
 * VITE_DEBUG_MODE=true のビルドでのみ蓄積される、画面表示用のログバッファ。
 *
 * LIFF ブラウザは開発者ツールを開けないため、端末上で起きたことを画面に出す必要がある。
 * `LiffDebugInfo` が購読して「実行ログ」に表示する。デバッグモードが無効なビルドでは
 * すべて no-op になるため、本番の挙動には影響しない。
 */

// 端末上での表示なので、古いものは捨てて直近だけ残す
const MAX_LOGS = 200;

type Listener = (logs: string[]) => void;

const logs: string[] = [];
const listeners = new Set<Listener>();

export const isDebugMode = (): boolean => import.meta.env.VITE_DEBUG_MODE === 'true';

const notify = (): void => {
  const snapshot = [...logs];
  listeners.forEach((listener) => listener(snapshot));
};

export const pushDebugLog = (message: string): void => {
  if (!isDebugMode()) return;
  logs.push(`[${new Date().toLocaleTimeString()}] ${message}`);
  if (logs.length > MAX_LOGS) logs.splice(0, logs.length - MAX_LOGS);
  console.log(`[Debug] ${message}`);
  notify();
};

export const clearDebugLogs = (): void => {
  logs.length = 0;
  notify();
};

/** 購読開始時に現在のログを1度流すため、マウント前に積まれたログも表示できる */
export const subscribeDebugLogs = (listener: Listener): (() => void) => {
  listeners.add(listener);
  listener([...logs]);
  return () => {
    listeners.delete(listener);
  };
};

/** 例外を1行に潰す。DOMException / Error / それ以外を同じ形式で扱う */
export const formatError = (err: unknown): string => {
  if (err instanceof Error) return `${err.name}: ${err.message}`;
  return String(err);
};
